import React from "react";
import  '../../../style.css'
import { StyleSheet, css } from "aphrodite";
export default function ProductAux({mainImage, title, productTpe, description, 
    secondImage, firstMiniTitle, fisrtMiniDescription, thirdImage, secondMiniDescription,
    secondMiniTitle, specs, otherImages}){
        const styles = StyleSheet.create({
            firstContainerStyle: {
                width: '100%',
                display: 'flex',
                height: '500px',
                
            },
            imageStyle: {
                width: '100%',
                objectFit: 'cover',
                filter: 'grayscale(70%) blur(2px)'
            },
            secondContainerStyle: {
                display: 'flex',
                justifyContent: ' center',
                alignItems: 'center',
                backgroundColor: '#011a39',
                gap: '3rem',
                padding: '0 0 20px 0',
                flexDirection:'column',
                "@media (min-width: 1024px)": {
                    height: "200px",
                    flexDirection:'row',
                }
            },
            titleContainerStyle: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: ' start',
                alignItems: 'center',
                gap: '1rem'
                
            },
            titleStyle: {
                fontFamily: 'Oswald',
                fontStyle: "bold",
                fontSize: "3rem",
                textAlign: "center",
                color: '#fec803'
            },
            productTypeStyle: {
                fontFamily: 'Oswald',
                fontStyle: "bold",
                fontSize: "1rem",
                textAlign: "center",
                color: '#fec803'
            },
            desriptionStyle: {
                color: '#F0EFEC',
                textAlign: 'justify',
                fontFamily: "Montserrat",
                width: '80%',
                "@media (min-width: 1024px)": {
                    width: '60%'
                }
            },
            thirdContainerStyle:{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: ' center',
                alignItems: 'center',
                backgroundColor: '#F0EFEC',
                gap: '40px',
                padding: '0 0 20px 0',
                "@media (min-width: 1024px)": {
                    padding: "3rem 0",
                }
    
            },
            featuredHiglitsStyle: {
                fontFamily: 'Oswald',
                fontStyle: "bold",
                fontSize: "3rem",
                textAlign: "center",
                color: '#011a39',
            },
            imageAndTextContainerStyle: {
                display: 'flex',
                justifyContent: ' center',
                alignItems: 'center',
                flexDirection:'column',
                gap: '20px',
                "@media (min-width: 1024px)": {
                    flexDirection: 'row'
                }
            },
            imageAndTextStyle: {
                objectFit: 'contain',
                width:'80%',
                "@media (min-width: 1024px)": {
                    width:'30%',
                    height: ' 400px',
                }
            },
            firstDescriptionTextContainerStyle:{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: ' center',
                alignItems: 'center',
                gap: '20px',
                width: '60%',
                
            },
            miniTitleStyle: {
                fontFamily: 'Oswald',
                fontStyle: "bold",
                fontSize: "2rem",
                textAlign: "center",
                color: '#011a39',
                "@media (min-width: 1024px)": {
                    width: '60%',
                }
            },
            miniDescriptionStyle: {
                textAlign: 'justify',
                fontFamily: "Montserrat",
                "@media (min-width: 1024px)": {
                    width: '80%',
                }
            },
            fourthContainerStyle:{
                display : 'flex',
                flexDirection: 'column',
                justifyContent: ' center',
                alignItems: 'center',
                backgroundColor: "#011a39",
                gap: "2rem",
                padding: "3rem 0",
                width:'100%'
            },
            spesificationStyle: {
                fontFamily: 'Oswald',
                fontStyle: "bold",
                fontSize: "3rem",
                textAlign: "center",
                color: '#fec803',
            },
            specsStyle: {
                display: 'flex',
                flexDirection: 'column',
                fontFamily: "Montserrat",
                color: '#F0EFEC',
                padding:'5px'
            },
            galaryContainerStyle: {
                padding: '20px',
                backgroundColor: '#F0EFEC',
                "@media (min-width: 1024px)": {
                    display: "grid",
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    gridGap: '1rem',
                    
                }
            },
            galaryImageStyle: {
                width: "100%",
                height: "400px",
                objectFit: 'cover',
                borderRadius: '10px'
            }
        })    
    return(
        <>
            <div className={css(styles.firstContainerStyle)}>
                <img className={css(styles.imageStyle)} src={mainImage}></img>
            </div>
            <div className={css(styles.secondContainerStyle)}>
                <div className={css(styles.titleContainerStyle)}>
                    <div className={css(styles.titleStyle)}>{title}</div>
                    <div className={css(styles.productTypeStyle)}>{productTpe}</div>
                </div>
                <div className={css(styles.desriptionStyle)}>{description}</div>
            </div>
            <div className={css(styles.thirdContainerStyle)}>
                <div className={css(styles.featuredHiglitsStyle)}>FEATURED HIGHLIGHTS</div>
                <div className={css(styles.imageAndTextContainerStyle)}>
                    <img className={css(styles.imageAndTextStyle)} src={secondImage}></img>
                    <div className={css(styles.firstDescriptionTextContainerStyle)}>
                        <div className={css(styles.miniTitleStyle)}>{firstMiniTitle}</div>
                        <div className={css(styles.miniDescriptionStyle)}>{fisrtMiniDescription}</div>
                    </div>
                </div>
                <div className={css(styles.imageAndTextContainerStyle)}>
                    <div className={css(styles.firstDescriptionTextContainerStyle)}>
                        <div className={css(styles.miniTitleStyle)}>{secondMiniTitle}</div>
                        <div className={css(styles.miniDescriptionStyle)}>{secondMiniDescription}</div>
                    </div>
                    <img className={css(styles.imageAndTextStyle)} src={thirdImage}></img>
                </div>
            </div>
            <div className={css(styles.fourthContainerStyle)}>
                <div className={css(styles.spesificationStyle)}> SPECIFICATIONS</div>
                <ul>
                    {
                        specs  ? specs.map((spec)=>{
                            return <il className={css(styles.specsStyle)}>{spec}</il>
                        }) : <></>
                    }
                </ul>
            </div>
            <div className={css(styles.galaryContainerStyle)}>
                {
                    otherImages  ? otherImages.map((auxImg)=>{
                        return <img className={css(styles.galaryImageStyle)} src={auxImg}></img>
                    }) : <></>
                }
                <img className={css(styles.galaryImageStyle)} src={mainImage}></img>
                <img className={css(styles.galaryImageStyle)} src={secondImage}></img>
                <img className={css(styles.galaryImageStyle)} src={thirdImage}></img>
            </div>

        </>
    )
}